export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        ".": "",
        "...": "",
        "2 dni": "",
        "2 miesiące": "",
        "2 tygodnie": "",
        "3 dni": "",
        "3 miesiące": "",
        "4 dni": "",
        "5 dni": "",
        "6 dni": "",
        "Aby skonfigurować wysyłkę, należy uzułenić wymagane pola.": "",
        "Adres": "",
        "Adres email": "",
        "Adres email jest pusty.": "",
        "Adres email odbiorcy": "",
        "Adres URL": "",
        "Akcent": "",
        "Akceptacja": "",
        "Akceptacja dokumentów": "",
        "Akceptacja dokumentu": "",
        "Akceptacja własnych dokumentów": "",
        "Akceptacja wszystkich dokumentów": "",
        "Akceptowalny typ plików": "",
        "Akceptowany format danych": "",
        "Akceptuj": "",
        "Akcje": "",
        "Akordeon": "",
        "Aktualizacja definicji": "",
        "Aktualizacja dokumentu": "",
        "Aktualizacja encji": "",
        "Aktualizacja wpisu": "",
        "Aktualizowane pola": "",
        "Aktualizuj": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywny": "",
        "Ankieta": "",
        "Anonimizacja": "",
        "Anonimowy": "",
        "Anulowany": "",
        "Anuluj": "",
        "Aplikacja": "",
        "application/json": "",
        "application/x-www-form-urlencoded": "",
        "Audio": "",
        "Automatyzacja": "",
        "Baza danych": "",
        "Bazowy model danych": "",
        "Bezpieczeństwo": "",
        "Bieżący dokument": "",
        "Widget służy do budowania obiektu z wybranych wartości.": "",
        "Widget służy do parsowania szablonów w języku Liquid.": "",
        "Widget służy do renderowania MJML na HTML": "",
        "Widget umożliwia przygotowanie dowolnego skryptu w języku C#.": "",
        "Widget wyzwala scenariusz po wykonaniu akcji wybranej w polu": "",
        "Widget zwracana wybrany szablon wiadomości email.": "",
        "Błąd": "",
        "Błędne": "",
        "Błędny": "",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "",
        "Bool": "",
        "brak": "",
        "Brak": "",
        "Brak danych": "",
        "Brak dodanych kolumn": "",
        "Brak drugiej wersji do porównania": "",
        "Brak odpowiedzi": "",
        "Brak różnic między wybranymi wersjami": "",
        "Brak właściwości do konfiguracji.": "",
        "brak wyboru...": "",
        "Brak wyników": "",
        "Build": "",
        "Cache": "",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "",
        "Cache po stronie serwera": "",
        "Cache-Control": "",
        "Cechy": "",
        "Checkbox": "",
        "Ciemny": "",
        "Cyfry": "",
        "Czas pomiędzy": "",
        "Czas rozpoczęcia": "",
        "Czas trwania": "",
        "Czas trwania: %0": "",
        "Czas zakończenia": "",
        "Cztery kolumny": "",
        "Czy na pewno chcesz zaktualizować definicje wszystkich dokumentów?": "",
        "Dalej": "",
        "Dane": "",
        "Dane formularza są przechowywane w obiekcie Entry.": "",
        "Dane odbiorcy": "",
        "Dane osobowe": "",
        "Dane tabelaryczne": "",
        "Dane techniczne": "",
        "Dane z formularza zapisywane anonimowo": "",
        "Data": "",
        "Data dodania": "",
        "Data i czas": "",
        "Data rozpoczęcia": "",
        "Data rozpoczęcia publikacji": "",
        "Data wywołania": "",
        "Data zakończenia": "",
        "Data zakończenia publikacji": "",
        "Data: %0 | Autor: %1 | Status: %2": "",
        "Data: %0 | Status: %1": "",
        "DateTime": "",
        "Dedykowane": "",
        "Definicja": "",
        "Definicja (JSON)": "",
        "Definicja formularza znajduje się w obiekcie Form.": "",
        "Definicje": "",
        "Definicje zostały zaktualizowane.": "",
        "DELETE: Usunięcie wpisu": "",
        "Design Studio": "",
        "Diagram": "",
        "Diagram jest nieprawidłowy, nie zawiera żadnego wyzwalacza.": "",
        "Diagram jest nieprawidłowy, zawiera więcej niż jeden wyzwalacz.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" jest elementem dwóch różnych pętli.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie posiada rodzica.": "",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera niezgodną liczbę początków i zakończeń pętli.": "",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera zagnieżdżone pętle.": "",
        "dla wybranego modelu danych.": "",
        "dla wybranego modułu dynamicznego.": "",
        "Długość czasu przechowywania": "",
        "Długość geograficzna": "",
        "do": "",
        "Do": "",
        "Dodaj": "",
        "Dodaj dni": "",
        "Dodaj dokument": "",
        "Dodaj element": "",
        "Dodaj endpoint": "",
        "Dodaj formularz": "",
        "Dodaj grupę": "",
        "Dodaj kategorię": "",
        "Dodaj komponent": "",
        "Dodaj moduł": "",
        "Dodaj nową wersję dokumentu": "",
        "Dodaj obraz": "",
        "Dodaj parametr": "",
        "Dodaj podsumowanie": "",
        "Dodaj pole": "",
        "Dodaj pozycję": "",
        "Dodaj punkt": "",
        "Dodaj scenariusz": "",
        "Dodaj sekcję": "",
        "Dodaj stronę": "",
        "Dodaj warunek": "",
        "Dodaj webhooka": "",
        "Dodaj wiersz": "",
        "Dodaj wpis": "",
        "Dodaj wydarzenie": "",
        "Dodaj źródło": "",
        "Dodane": "",
        "Dodane przez": "",
        "Dodanie endpointu": "",
        "Dodanie komponentu": "",
        "Dodanie modułu": "",
        "Dodanie webhooka": "",
        "Dodanie źródła danych": "",
        "Dodano": "",
        "Dodano za dużo plików (maksymalnie %0).": "",
        "Dodatkowe pola do wyszukiwarki": "",
        "Dodawanie": "",
        "Dodawanie dokumentów": "",
        "Dodawanie i edycja własnych dokumentów": "",
        "Dodawanie wartości dwóch kolumn": "",
        "Dokument": "",
        "Dokument został usunięty.": "",
        "Dokumenty": "",
        "Dołączanie plików": "",
        "Domyślna wartość": "",
        "Domyślnie ukryte": "",
        "Domyślnie widoczne": "",
        "Domyślny": "",
        "Dopuść brak odpowiedzi": "",
        "Dostęp do modułu": "",
        "Double": "",
        "dowolnej wybranej wersji": "",
        "Dowolny": "",
        "Dozwolone rozszerzenia": "",
        "Dozwolone rozszerzenia plików": "",
        "Dozwolone są tylko małe i duże litery": "",
        "Dozwolone są tylko małe litery i znak -": "",
        "Drugie imię": "",
        "Duże litery": "",
        "Duży": "",
        "Duży układ siatki": "",
        "Dwie kolumny": "",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "",
        "Dyrektywa przechowywania": "",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywy zakresu": "",
        "Działania masowe": "",
        "Dzielenie": "",
        "dzień": "",
        "Dzień": "",
        "Dzisiaj": "",
        "Edycja definicji": "",
        "Edycja dokumentów": "",
        "Edycja dokumentu": "",
        "Edycja endpointu": "",
        "Edycja komponentu": "",
        "Edycja modułu": "",
        "Edycja scenariusza": "",
        "Edycja w popupie": "",
        "Edycja webhooka": "",
        "Edycja wszystkich dokumentów": "",
        "Edycja źródła danych": "",
        "Edytor": "",
        "Edytor lokalizowany": "",
        "Edytuj": "",
        "Edytuj dokument": "",
        "Edytuj punkt": "",
        "Edytuj wiersz": "",
        "Edytuj wpis": "",
        "Edytuj wydarzenie": "",
        "Eksport do Excela": "",
        "Eksport dokumentów": "",
        "Element nadrzędny": "",
        "Element został usunięty": "",
        "Email": "",
        "Endpoint został dodany.": "",
        "Endpoint został usunięty.": "",
        "Endpoint został zaktualizowany.": "",
        "Eskportuj": "",
        "Etap": "",
        "Etykieta": "",
        "Etykiety": "",
        "False": "",
        "Filmy": "",
        "Filtrowanie": "",
        "Filtrowanie listy dokumentów": "",
        "Filtry": "",
        "Formularz": "",
        "Formularz bazuje na nieaktualnej wersji definicji.": "",
        "Formularz jest wymagany": "",
        "Formularz został dodany.": "",
        "Formularz został skopiowany.": "",
        "Formularz został utworzony.": "",
        "Formularz został zaakceptowany.": "",
        "Formularz został zaktualizowany.": "",
        "Formularze": "",
        "Formuła jest nieprawidłowa": "",
        "Funkcjonalności": "",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "",
        "GET: Pobranie danych": "",
        "GET: Pobranie wpisu": "",
        "GET: Schemat (definicja formularza)": "",
        "Grafika wektorowa": "",
        "Harmonogram": "",
        "Hasło": "",
        "Hierarchia": "",
        "Hierarchiczny": "",
        "Historia": "",
        "i obserwując wynik w oknie konsoli.": "",
        "Id": "",
        "Id dokumentu": "",
        "Id encji": "",
        "ID operacji": "",
        "ID procesu": "",
        "Id wpisu": "",
        "Ikona": "",
        "Ikona jest wymagana": "",
        "Ilość elementów: %0": "",
        "Ilość powtórzeń pętli": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość wierszy": "",
        "Ilość wyników do odrzucenia": "",
        "Ilość wyników do pobrania": "",
        "Ilość znaków": "",
        "Ilość znaków odpowiedzi": "",
        "Imię": "",
        "Import": "",
        "Import modułu": "",
        "Importuj definicję formularza": "",
        "Importuj definicję scenariusza": "",
        "Indeksowanie": "",
        "Info": "",
        "Informacja": "",
        "input1 < input2": "",
        "Instrukcje": "",
        "Int": "",
        "Jasny": "",
        "Jedna kolumna": "",
        "Język jest wymagany.": "",
        "JSON": "",
        "Kafelki": "",
        "Kalendarz": "",
        "Kanał jest wymagany": "",
        "Kategoria": "",
        "Kategoria jest wymagana": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Klucz": "",
        "Kod pocztowy": "",
        "Kod walidacji": "",
        "Kod źródłowy": "",
        "Kolor": "",
        "Kolor ikony": "",
        "Kolumna": "",
        "Kolumny": "",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "",
        "Komponent relacyjny": "",
        "Komponent został dodany.": "",
        "Komponent został usunięty.": "",
        "Komponent został zaktualizowany.": "",
        "Komponent źródłowy": "",
        "Komponenty": "",
        "Komunikat błędu": "",
        "Komunikat walidacji": "",
        "Konfiguracja": "",
        "Konfiguracja kolumn tabeli": "",
        "Konfiguracja listy": "",
        "Konfiguracja zaawansowana": "",
        "Konfiguracja zapytania": "",
        "Koniec pętli": "",
        "Konstruktor": "",
        "Konta użytkowników": "",
        "Kontrolka": "",
        "Kontrolka dostępna publicznie": "",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "",
        "Kontrolka wyboru (wybór wielokrotny)": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj definicję": "",
        "Kraj": "",
        "Kreator modułu": "",
        "Krok minut": "",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "",
        "Kroki": "",
        "Krótki opis": "",
        "Liczba": "",
        "Liczba całkowita": "",
        "Liczba dziesiętna": "",
        "Liczba wyników na stronie": "",
        "Linia": "",
        "linie": "",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "",
        "Lista ID": "",
        "Lista rozszerzeń oddzielona przecinkami.": "",
        "Lista rozwijana": "",
        "Lista sortowalna": "",
        "Litery": "",
        "Litery i cyfry": "",
        "Logi": "",
        "Lokalizacja": "",
        "Lokalizowane": "",
        "Long": "",
        "Łączenie treści": "",
        "Maksimum": "",
        "Maksymalna ilość plików": "",
        "Maksymalna rozdzielość obrazu po optymalizacji: %0x%1px": "",
        "Maksymalny rozmiar pliku w MB": "",
        "Maksymalny rozmiar pojedynczego pliku": "",
        "Małe litery": "",
        "Małe znaki": "",
        "Mały": "",
        "Mały układ siatki": "",
        "Mapa": "",
        "Mapowanie danych": "",
        "Mediana": "",
        "Metadane dokumentu": "",
        "Metoda": "",
        "Metoda musi zwracać obiekt \"entry.errors\".": "",
        "Miejsca po przecinku": "",
        "Miejsca publikacji": "",
        "Miejscowość": "",
        "miesiąc": "",
        "Miesiąc": "",
        "Minimalna ilość plików": "",
        "Minimalna szerokość": "",
        "Minimapa": "",
        "Minimum": "",
        "Mnożenie": "",
        "Model danych": "",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "",
        "module.": "",
        "Moduł": "",
        "Moduł będzie skonfigurowany z domyślnymi ustawieniami odpowiednimi do większości zastosowań.": "",
        "Moduł dynamiczny": "",
        "Moduł został dodany.": "",
        "Moduł został usunięty.": "",
        "Moduł został wyeksportowany.": "",
        "Moduł został zaktualizowany.": "",
        "Moduły": "",
        "Moduły dynamiczne": "",
        "Modyfikacja dokumentów": "",
        "Modyfikacja dokumentu w module": "",
        "Modyfikacja rekordu w bazie danych": "",
        "Moje dokumenty": "",
        "Moje punkty": "",
        "Moje wydarzenia": "",
        "Możliwość wielokrotnego wyboru": "",
        "Multimedia": "",
        "multipart/form-data": "",
        "Na wejściu należy podać dane wejściowe, a następnie zadeklarować": "",
        "Na wyjściu zwracana jest encja wybranego modelu danych.": "",
        "Na wyjściu zwracany jest model wpisu wybranego formularza dynamicznego.": "",
        "Nadawanie uprawnień do dokumentów": "",
        "Nadawanie uprawnień do własnych dokumentów": "",
        "Nadawanie uprawnień do wszystkich dokumentów": "",
        "Nagłówek": "",
        "Nagłówki cache": "",
        "Należy wybrać model danych.": "",
        "Należy wybrać przynajmniej jedną akcję.": "",
        "Należy wybrać przynajmniej jedną właściwość modelu.": "",
        "Należy zapisać zmiany w scenariuszu przed uruchomieniem procesu.": "",
        "Następny": "",
        "Nazwa": "",
        "Nazwa akcji": "",
        "Nazwa etapu": "",
        "Nazwa formularza": "",
        "Nazwa jest wymagana": "",
        "Nazwa kategorii": "",
        "Nazwa kolumny": "",
        "Nazwa kolumny z obrazem": "",
        "Nazwa kolumny z opisem": "",
        "Nazwa kolumny z wartością": "",
        "Nazwa komponentu": "",
        "Nazwa modelu": "",
        "Nazwa modułu": "",
        "Nazwa musi mieć co najmniej 3 znaki": "",
        "Nazwa musi mieć co najmniej 4 znaki": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "",
        "Nazwa nie może być dłuższy niż 50 znaków": "",
        "Nazwa operacji": "",
        "Nazwa pola jest wymagana": "",
        "Nazwa przycisku ``Dalej``": "",
        "Nazwa przycisku ``Wstecz``": "",
        "Nazwa przycisku ``Wyślij``": "",
        "Nazwa scenariusza": "",
        "Nazwa sekcji w menu": "",
        "Nazwa sekcji...": "",
        "Nazwa techniczna": "",
        "Nazwa warunku jest wymagana": "",
        "Nazwa warunku musi być unikalna": "",
        "Nazwa warunku musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "",
        "nazwa warunku...": "",
        "Nazwa webhooka": "",
        "Nazwa wyświetlana": "",
        "Nazwa zdarzenia": "",
        "Nazwa zmiennej jest wymagana": "",
        "Nazwa zmiennej musi być unikalna": "",
        "nazwa zmiennej...": "",
        "Nazwa źródła": "",
        "Nazwa źródła danych": "",
        "Nazwisko": "",
        "Nazwy wartości": "",
        "Nazwy właściwości modelu": "",
        "Nie": "",
        "Nie dotyczy plików svg": "",
        "Nie masz dostępu do tego modułu": "",
        "Nie masz uprawnień do tego dokumentu": "",
        "Nie można tworzyć zapętlonych powiązań.": "",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "",
        "Nie podano wymaganej ilości znaków: %0.": "",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się uruchomić procesu.": "",
        "Nie wybrano użytkownika.": "",
        "Nie znaleziono formularza.": "",
        "Nieaktywny": "",
        "Niepoprawne wyrażenie regularne": "",
        "Nieprawidłowa definicja": "",
        "Niestandardowe logo i stopka": "",
        "Niestandardowy błąd": "",
        "Niewidoczne": "",
        "Nigdy": "",
        "no-store (wyłącza cache)": "",
        "Nowa data": "",
        "Nowa lokalizacja": "",
        "Nowa wartość": "",
        "Numer domu": "",
        "Numer mieszkania": "",
        "Obiekt JSON": "",
        "Obok siebie": "",
        "Obsługiwane kanały": "",
        "Obsługiwane powiadomienia": "",
        "Obsługiwane są wszystkie powiadomienia.": "",
        "od": "",
        "Od": "",
        "od %0": "",
        "Odejmowanie": "",
        "Odpowiedzi": "",
        "Odpowiedzi: %0 na %1": "",
        "Odpowiedź dowolna": "",
        "Odstęp": "",
        "Omnitool": "",
        "Opcje": "",
        "Operacje": "",
        "Operacje w pętli": "",
        "Operacje wykonane": "",
        "Opis": "",
        "Opis błędu": "",
        "Opis źródła": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Ostrzeżenie": "",
        "Parametry wejściowe pochodzą z innych podpiętych widgetów.": "",
        "Parametry wejściowe skryptu": "",
        "Parametry, wymagane do wykonania zapytania:": "",
        "Parser Liquid": "",
        "Pasek": "",
        "Pasek postępu": "",
        "Pełna kontrola nad wszystkimi ustawieniami modułu oraz endpointami API.": "",
        "Pełna treść wiadomości": "",
        "Pełny": "",
        "Pełny dokument": "",
        "Pierwiastkowanie wartości kolumny": "",
        "Pigułki": "",
        "Placeholder": "",
        "Pliki": "",
        "Pliki: %0": "",
        "Po": "",
        "po elementach kolekcji": "",
        "Pobieranie dokumentów": "",
        "Pobieranie encji": "",
        "Pobieranie i aktualizacja encji": "",
        "Pobieranie i usuwanie encji": "",
        "Początek pętli": "",
        "Początkowa ilość wierszy": "",
        "Podaj ID dokumentu lub nazwę parametru wejściowego.": "",
        "Podaj nazwę formularza": "",
        "Podaj nazwę scenariusza": "",
        "Podaj nową nazwę": "",
        "Podajemy go w formie jednoliniowej. Przykład:": "",
        "Podana nazwa jest zajęta.": "",
        "Podana wartość jest nieprawidłowa.": "",
        "Podane ręcznie": "",
        "Podanie nazwy jest wymagane.": "",
        "Podano adres": "",
        "Podano nieprawidłowe dane": "",
        "Podano nieprawidłowe dane.": "",
        "Podano nieprawidłowe dane. (%0)": "",
        "Podgląd": "",
        "Podgląd formularza": "",
        "Podgląd listy": "",
        "Podgląd tabeli": "",
        "Podgląd wyniku jest niedostępny. Aby zobaczyć podgląd, scenariusz musi się wykonać poprawnie przynajmniej jeden raz.": "",
        "Podgląd wyniku wybranego etapu": "",
        "Podkreślenie": "",
        "Podpis": "",
        "Podproces": "",
        "Podstawowe": "",
        "Podstawowe operacje na datach": "",
        "Podstawowe operacje na liczbach": "",
        "Podstawowe operacje tekstowe": "",
        "Podstawowe operacje warunkowe": "",
        "Pojedynczy formularz": "",
        "Pojedynczy wybór": "",
        "Pokaż etykietę": "",
        "Pokaż numery stron": "",
        "Pokaż numery tygodnia na kalendarzu": "",
        "Pokaż przycisk ``Wyślij``": "",
        "Pokaż starsze wersje": "",
        "Pokaż tytuł formularza": "",
        "Pokaż tytuł sekcji": "",
        "Pokaż tytuł strony": "",
        "Pokaż tytuły stron": "",
        "pokaż więcej...": "",
        "Pola": "",
        "Pole": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"%0\" jest wymagane. (%1)": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "",
        "Pole \"Akcje\" jest wymagane.": "",
        "Pole \"Drugie imię\" jest wymagane.": "",
        "Pole \"Id dokumentu\" jest wymagane.": "",
        "Pole \"Id encji\" jest wymagane.": "",
        "Pole \"Imię\" jest wymagane.": "",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "",
        "Pole \"Model\" jest wymagane.": "",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "",
        "Pole \"Moduł\" jest wymagane.": "",
        "Pole \"Nazwa modelu\" jest wymagane.": "",
        "Pole \"Nazwisko\" jest wymagane.": "",
        "Pole \"Podproces\" jest wymagane.": "",
        "Pole \"Pole\" jest wymagane.": "",
        "Pole \"Sekcja modułu\" jest wymagane.": "",
        "Pole \"Sekcja\" jest wymagane.": "",
        "Pole \"Typ agregacji\" jest wymagane.": "",
        "Pole \"Tytuł\" jest wymagane.": "",
        "Pole \"Wyrażenie EQL\" jest wymagane.": "",
        "Pole jest wymagane": "",
        "Pole może zawierać jedynie cyfry.": "",
        "Pole może zawierać jedynie cyfry. (%0)": "",
        "Pole może zawierać jedynie litery i cyfry.": "",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "",
        "Pole może zawierać jedynie litery.": "",
        "Pole może zawierać jedynie litery. (%0)": "",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "",
        "Pole wymaga podania przynajmniej jednej cyfry.": "",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "",
        "Pole wymaga podania przynajmniej jednej małej litery.": "",
        "Pole wymagane": "",
        "Pole zawiera": "",
        "Pomoc": "",
        "Poprawne": "",
        "Poprawność kompilacji skryptu można przetestować, wciskając przycisk": "",
        "Poprawny": "",
        "Poprzedni": "",
        "Poprzednia lokalizacja": "",
        "Porównaj %0": "",
        "Porównaj wersje": "",
        "Porównania": "",
        "Porównanie": "",
        "Porównanie wersji": "",
        "Porównywana wersja": "",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "",
        "POST: Upload załączników": "",
        "POST: Utworzenie wpisu": "",
        "POST: Zapisanie zmian": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdź akceptację": "",
        "Potwierdź usunięcie": "",
        "Powiadomienia": "",
        "Powiadomienie jest wymagane": "",
        "Powiadomienie systemowe": "",
        "Powiązana kontrolka": "",
        "Powiększ": "",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "",
        "Powrót": "",
        "Powtórzenia": "",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "",
        "Poziom dostępu do webhooka": "",
        "Poziom dostępu użytkownika": "",
        "pozwala na wykorzystanie zaawansowanego edytora tekstu.": "",
        "Pozwól na dodawanie wierszy": "",
        "Pozwól na sortowanie wierszy": "",
        "Pozycja na liście": "",
        "Pozycje zostały zapisane.": "",
        "pół roku": "",
        "Prezentacja": "",
        "private (tylko cache przeglądarki)": "",
        "Procent": "",
        "Proces": "",
        "Proces został uruchomiony.": "",
        "Projekt": "",
        "Proste uprawnienia": "",
        "Przed": "",
        "Przedrostek": "",
        "Przejdź do kolejnego kroku gdy:": "",
        "Przekroczono dozwoloną ilość znaków: %0.": "",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "",
        "Przełącznik": "",
        "Przeniesienie wpisu do kosza": "",
        "Przeniesione": "",
        "Przeniesiono": "",
        "Przenieś niżej": "",
        "Przenieś wyżej": "",
        "Przerwany": "",
        "Przesuń do góry": "",
        "Przesuń na dół": "",
        "Przybliżenie": "",
        "Przybornik": "",
        "Przykład:": "",
        "Przykładowa struktura danych": "",
        "Przykłady": "",
        "Przykłady konfiguracji": "",
        "przypisz wynik etapu...": "",
        "Przyrostek": "",
        "Przywrócenie wpisu z kosza": "",
        "public (cache przeglądarki i proxy)": "",
        "PUT: Aktualizacja wpisu": "",
        "Pytania": "",
        "Query string": "",
        "Radio": "",
        "Reaguj na zmiany wybranych właściwości": "",
        "Reguła walidacji": "",
        "Relacyjne": "",
        "Renderer MJML": "",
        "Request body": "",
        "Rest API": "",
        "RESTful API": "",
        "Rezultat": "",
        "Ręczne uruchomienie": "",
        "Rodzaj odpowiedzi": "",
        "Rodzaj pętli": "",
        "Rodzaj zwracanego wyniku": "",
        "rok": "",
        "Rok": "",
        "Rozmiar okna popup": "",
        "Rozmiar podawany w bajtach.": "",
        "Rozmieść równomiernie": "",
        "Równość": "",
        "Satysfakcja": "",
        "Scenariusz": "",
        "Scenariusz aktywny": "",
        "Scenariusz jest aktywowany po wywołaniu wybranego Webhooka.": "",
        "Scenariusz jest aktywowany po wywołaniu wybranego zdarzenia.": "",
        "Scenariusz jest aktywowany według wybranego hamonogramu.": "",
        "Scenariusz nie jest aktywny": "",
        "Scenariusz został dodany.": "",
        "Scenariusz został usunięty.": "",
        "Scenariusz został utworzony.": "",
        "Scenariusz został zaktualizowany.": "",
        "Scrollowalne okna popup": "",
        "Sekcja": "",
        "Sekcja lokalizowana": "",
        "Sekcja modułu": "",
        "Sekcja powtarzalna": "",
        "Selektor ikony": "",
        "Selektor kolorów": "",
        "Server Side Cache": "",
        "Skala 1-5": "",
        "Skrypt (C#)": "",
        "słowa": "",
        "Słownik": "",
        "Sortowanie": "",
        "Sparametryzowane": "",
        "Specjalizowane": "",
        "Specyfikacja": "",
        "Sposób dystrybucji": "",
        "Sposób prezentacji zakładek": "",
        "Sprawdzenie czy pusty": "",
        "Stała wartość": "",
        "Stan": "",
        "Standardowe uprawnienia": "",
        "Standardowy": "",
        "Start": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "",
        "Status modułu": "",
        "Status webhooka": "",
        "Status żądania": "",
        "string": "",
        "String": "",
        "Strona": "",
        "Strona %0": "",
        "Studio": "",
        "Stwierdzenie": "",
        "Styl": "",
        "Sukces": "",
        "Suma": "",
        "Switch": "",
        "Sygnatura dokumentu": "",
        "Symbol": "",
        "Symbol jest wymagany": "",
        "Symbol jest zajęty": "",
        "Symbol modułu": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol musi mieć co najmniej 3 znaki": "",
        "Symbol musi mieć co najmniej 4 znaki": "",
        "Symbol nie może być dłuższy niż 10 znaków": "",
        "Symbol nie może być dłuższy niż 20 znaków": "",
        "Symbol w adresie URL": "",
        "Synchronizuj": "",
        "System": "",
        "Szablon email": "",
        "Szablon modułu": "",
        "Szablon wiadomości email": "",
        "Szablony definiowane są w ": "",
        "Szczegóły": "",
        "Szerokość": "",
        "Szerokość geograficzna": "",
        "Średni": "",
        "Średnia": "",
        "Tabela": "",
        "Tak": "",
        "Tak/Nie": "",
        "Tekst": "",
        "Tekst lokalizowany": "",
        "Tekst zastępczy": "",
        "Telefon": "",
        "Teraz": "",
        "Test": "",
        "Testuj": "",
        "Testuj zapytanie": "",
        "Treści odpowiedzi są wymagane": "",
        "Treści pytań są wymagane": "",
        "Treść": "",
        "True": "",
        "Trwa porównywanie wersji...": "",
        "Tryb prezentacyjny": "",
        "Trzy kolumny": "",
        "Tworzenie dokumentów": "",
        "Tworzenie dokumentu": "",
        "Tworzenie encji": "",
        "tydzień": "",
        "Tydzień": "",
        "Tylko do odczytu": "",
        "Typ agregacji": "",
        "Typ kontentu": "",
        "Typ odbiorcy": "",
        "Typ pola": "",
        "Typ zmiennej": "",
        "Tytuł": "",
        "Tytuł formularza jest wymagany": "",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "",
        "Tytuł sekcji": "",
        "Układ": "",
        "Ukryta": "",
        "Ukryty": "",
        "Ulica": "",
        "Uprawnienia": "",
        "Uprawnienia do dokumentów": "",
        "Url": "",
        "Uruchom proces": "",
        "Uruchomienie harmonogramu": "",
        "Uruchomienie podprocesu": "",
        "Uruchomienie procesu": "",
        "Ustaw szerokości proporcjonalnie": "",
        "Ustawienia": "",
        "Ustawienia formularza": "",
        "Ustawienia zostały zapisane.": "",
        "Usunięcie dokumentu": "",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usunięcie wpisu": "",
        "Usunięta wartość": "",
        "Usunięte": "",
        "Usunięto": "",
        "Usuń": "",
        "Usuń dokument": "",
        "Usuń grupę": "",
        "Usuń logi gdy wykonywanie scenariusza": "",
        "Wyślij powiadomienie gdy wykonywanie scenariusza": "",
        "Usuń parametr": "",
        "Usuń pole": "",
        "Usuń pozycję": "",
        "Usuń punkt": "",
        "Usuń sekcję": "",
        "Usuń spacje": "",
        "Usuń warunek": "",
        "Usuń wydarzenie": "",
        "Usuwanie dokumentów": "",
        "Usuwanie encji": "",
        "Usuwanie własnych dokumentów": "",
        "Usuwanie wszystkich dokumentów": "",
        "Utworzenie wpisu": "",
        "Utwórz formularz": "",
        "Utwórz kopię formularza": "",
        "Utwórz kopię z": "",
        "Utwórz scenariusz": "",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "",
        "Użyj domyślnego zapytania SQL": "",
        "Użytkownik": "",
        "W widgetu zmiennej możliwe jest zdefiniowanie wartości dla jednego z podstawowych typów danych, do wykorzystania w dalszej części procesu.": "",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "",
        "W przyszłości": "",
        "w wyznaczonym zakresie": "",
        "W zapytaniu można używać nazw zmiennych z parametrów wejściowych skryptu, np.:": "",
        "Walidacja": "",
        "Walidacja danych": "",
        "Walidacja po stronie API": "",
        "Walidacja typów MIME": "",
        "Wariant powiadomienia": "",
        "Wartośc pola jest wymagana": "",
        "Wartość domyślna": "",
        "Wartość warunku jest wymagana": "",
        "Wartość zmiennej": "",
        "Warunek": "",
        "Warunek jest zdefiniowany przy użyciu wyrażenia lambda w C#. Przykład:": "",
        "Warunek nie zostanie spełniony": "",
        "Warunek tylko do odczytu": "",
        "Warunek widoczności": "",
        "Warunek wymagania": "",
        "Warunek zostanie spełniony": "",
        "Warunki": "",
        "Warunki logiczne": "",
        "Warunkowo": "",
        "Ważność": "",
        "Webhook": "",
        "Webhook został dodany.": "",
        "Webhook został usunięty.": "",
        "Webhook został zaktualizowany.": "",
        "Webhooki": "",
        "Wersja bazowa": "",
        "Wersja porównywana": "",
        "Wersje": "",
        "wersji zaakceptowanej": "",
        "Wersjonowany": "",
        "Wewnętrznie": "",
        "Widoczność": "",
        "Widoczność modułu w menu": "",
        "Widoczność sekcji w menu modułu": "",
        "Wielkość kroku": "",
        "Wielokrotny wybór": "",
        "Wiersz": "",
        "Wiersz %0": "",
        "więcej...": "",
        "Więcej...": "",
        "Wklej komponent": "",
        "Właściwości": "",
        "Właściwości szablonu": "",
        "Włącz": "",
        "Włącz tryb zaawansowany": "",
        "Włącz walidację po stronie API": "",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "",
        "Włączone": "",
        "Województwo": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "",
        "Wstaw kontrolkę": "",
        "Wstaw stronę": "",
        "Wstaw z dołu": "",
        "Wstaw z góry": "",
        "Wstaw z lewej strony": "",
        "Wstaw z prawej strony": "",
        "Wstecz": "",
        "Wszystkie": "",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "",
        "Wybierz moduł aby dodać sekcję lub nie wybieraj nic aby dodać nowy moduł": "",
        "wybierz moduł...": "",
        "wybierz sekcję...": "",
        "wybierz...": "",
        "Wybór": "",
        "Wybór języka": "",
        "Wybór wpływa na kolor szablonu.": "",
        "Wybór wpływa tylko na treść stopki.": "",
        "Wybór+": "",
        "Wybrana data jest mniejsza niż dozwolona %0.": "",
        "Wybrana data jest większa niż dozwolona %0.": "",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "",
        "Wybrana liczba jest większa niż dozwolona %0.": "",
        "Wybrane": "",
        "Wybrane dokumenty": "",
        "Wybrane: %0": "",
        "Wybranie przynajmniej jednego pola do aktualizacji jest wymagane.": "",
        "Wybranie przynajmniej jednego warunku jest wymagane.": "",
        "Wybrany użytkownik": "",
        "Wyczyść": "",
        "Wykonuje się": "",
        "Wyłączone": "",
        "Wyłuskaj dane do wybranej właściwości poprzez wyrażenie w formacie języka C#. Albo zostaw pole puste, wtedy zostanie zwrócony cały wynik.": "",
        "Wymaga autoryzacji": "",
        "Wymagane": "",
        "Wymagane jest wybranie formularza": "",
        "Wymagane jest wybranie kategorii": "",
        "Wymagane jest wybranie komponentu": "",
        "Wymagane jest wybranie modułu": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie źródła": "",
        "Wymagane jest wybranie źródła danych": "",
        "Wymagane znaki": "",
        "Wynik": "",
        "Wynik etapu (JSON)": "",
        "Wynik etapu jest wymagany": "",
        "Wynik testu": "",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "",
        "Wyrażenia warunkowe": "",
        "Wyrażenie EQL": "",
        "Wyrażenie jest prawidłowe. Udało się pobrać wartość z wyniku.": "",
        "Wyrażenie nie jest prawidłowe. Nie udało się pobrać wartości z wyniku.": "",
        "Wyrażenie regularne": "",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "",
        "Wysłanie emaila": "",
        "Wysłanie powiadomień": "",
        "Wystąpił błąd podczas próby importu definicji modułu.": "",
        "Wystąpił nieokreślony problem.": "",
        "Wyszukiwany ciąg znaków": "",
        "Wyślij": "",
        "Wyświetlanie dokumentów": "",
        "Wytnij": "",
        "Wywołanie powiadomienia": "",
        "Wywołanie webhooka": "",
        "Wywołanie zdarzenia": "",
        "Wyzwalacze": "",
        "Wzorzec": "",
        "Z uprawnieniami": "",
        "Z uprawnieniami do modułu": "",
        "Zaawansowane uprawnienia": "",
        "Zaawansowany edytor tekstu": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać szablon...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "",
        "Zaczyna sie od": "",
        "Zagrożenie": "",
        "Zaimportowano definicję modułu.": "",
        "Zakładki": "",
        "Zakończ edycje": "",
        "Zakończony": "",
        "zakończy się porażką": "",
        "zakończy się sukcesem": "",
        "Zakres": "",
        "Zakres czasu": "",
        "Zaktualizuj formularz": "",
        "Zaktualizuj najnowszą wersję dokumentu": "",
        "Zależna od kontrolki": "",
        "Zalogowany": "",
        "Załączniki": "",
        "Zamień wersje": "",
        "Zamknij": "",
        "Zaokrąglenie": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz i zamknij": "",
        "Zapisz kategorię": "",
        "Zapisz pozycje": "",
        "Zapisz zmiany": "",
        "Zapytanie SQL do pobrania po ID": "",
        "Zapytanie SQL do wyszukiwania": "",
        "Zasięg": "",
        "Zawiera": "",
        "Zawsze": "",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane kanały.": "",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane powiadomienia.": "",
        "Zdjęcia": "",
        "Zdjęcie": "",
        "Zgoda": "",
        "Zliczanie": "",
        "Zmiany": "",
        "Zmiany zostały zapisane.": "",
        "Zmienione": "",
        "Zmieniono": "",
        "Zmienna": "",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "",
        "Zmniejsz": "",
        "znaki": "",
        "Znaki specialne": "",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "",
        "Źródła danych": "",
        "Źródło danych": "",
        "źródło danych zostało dodane.": "",
        "Źródło danych zostało zaktualizowane.": "",
        "źródło zostało usunięte.": "",
        "Żródło danych": ""
    }
};
